module.exports = __webpack_public_path__ + "media/images/icons/outlined/close-e1c87f7418c6056dac83e39631d514a5.svg";